module.exports = {
  alertRed: '#DE4242', // c42-ui: $alert-color:
  grey: '#CCCCCC',
  darkSlateGrey: '#32363D', // c42-ui: $darkSlateGrey
  labelGrey: '#ABAFB5', // c42-ui: rgba($body-text-color, 0.5)
  lightGrey: '#EBEBEB', // c42-ui: $border-color, $button-background
  logoGrey: '#425563',
  logoOrange: '#FE5000',
  mediaObjectDividerGrey: '#EAEAEA',
  mutedText: 'rgba(50, 54, 61, 0.75)', // c42-ui: $body-secondary-text-color
  red: '#FF0000',
  softerText: 'rgba(50, 54, 61, 0.75)', // c42-ui: $body-secondary-text-color
  successGreen: '#8AC732', // c42-ui: $success
  white: '#FFFFFF', // c42-ui: $body-background-color
  primaryBlue: '#006FDE', // c42-ui: $primary
};